import { styled } from "styled-components";

export const CardContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.default[50]};
  padding: 24px 8px 24px 24px;
  gap: 16px;
  border-radius: 12px;
  display: grid;
  grid-template-columns: auto 140px;
  align-items: center;

  ${({ theme }) => theme.breakpoints.xs.query} {
    grid-template-columns: 1fr;
  }
`;

export const Price = styled.div`
  display: flex;
  flex-direction: column;

  > span {
    font-weight: 550;
    color: ${({ theme }) => theme.colors.default[500]};
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Cost = styled.p`
  color: ${({ theme }) => theme.colors.primary.default};
  font-weight: 700;
  font-size: 19px;
  letter-spacing: 0.03em;
  line-height: 24px;
`;
